var _rule = require("../rule.js");

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _rule2.default.makeRule({
    name: "image-in-table",
    severity: _rule2.default.Severity.BULK_WARNING,
    selector: "table image",
    message: "Image in table:\ndo not put images inside of tables."
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/gorgon/rules/image-in-table.js
 ** module id = 219
 ** module chunks = 0 2
 **/